export default class Scopes {
	constructor() {
		this.canvas = {
			parade: document.getElementById("scope-parade-canvas"),
			waveform: document.getElementById("scope-waveform-canvas"),
			vectorscope: document.getElementById("scope-vectorscope-canvas"),
		};
		this.lastParadeWidth = 0;
		this.lastParadeHeight = 0;
		this.lastParadeImgData = null;
		this.skip = 4;
		this.ticksColor = "rgb(196,140,20)";
	}

	setMaxSize() {
		let space = UI.getAvailableMainSpace();
		Object.keys(this.canvas).forEach((el, key) => {
			this.canvas[el].style.maxWidth = `${space.width}px`;

			// vectorscope only
			if (key == 2) this.canvas[el].closest(".canvas-container").style.maxWidth = `${space.width}px`;
		});
	}

	init() {
		this.setMaxSize();
		// this.updateAll();
		let longerSide;
		lutify.imageWidth >= lutify.imageHeight ? (longerSide = lutify.imageWidth) : (longerSide = lutify.imageheight);

		if (longerSide <= 1024) this.skip = 2;
		else this.skip = 4;
		// console.log('SKIP:', this.skip);
	}

	getPixels() {
		let gl = gpu.renderer.getContext();
		let width = lutify.imageWidth;
		let height = lutify.imageHeight;
		let pixels = new Uint8Array(width * height * 4);
		gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);

		var result = new Uint8Array((width / this.skip) * (height / this.skip) * 4);
		var d = 0;
		for (var y = 0; y < height; y += this.skip) {
			for (var x = 0; x < width; x += this.skip) {
				for (var c = 0; c < 4; c++) {
					result[d++] = pixels[(y * width + x) * 4 + c];
				}
			}
		}
		return result;
	}

	updateAll() {
		let pixels = this.getPixels();
		this.doParade(pixels, lutify.imageWidth / this.skip, lutify.imageHeight / this.skip, this.canvas.parade);
		this.doWaveForm(pixels, lutify.imageWidth / this.skip, lutify.imageHeight / this.skip, this.canvas.waveform);
		this.doVectorScope(pixels, lutify.imageWidth / this.skip, lutify.imageHeight / this.skip, this.canvas.vectorscope);
	}

	update(scope) {
		let pixels = this.getPixels();
		if (scope == "parade") this.doParade(pixels, lutify.imageWidth / this.skip, lutify.imageHeight / this.skip, this.canvas.parade);
		else if (scope == "waveform")
			this.doWaveForm(pixels, lutify.imageWidth / this.skip, lutify.imageHeight / this.skip, this.canvas.waveform);
		else if (scope == "vectorscope")
			this.doVectorScope(pixels, lutify.imageWidth / this.skip, lutify.imageHeight / this.skip, this.canvas.vectorscope);
	}

	scaleImageData(imageData, xs, ys) {
		var newCanvas = document.createElement("CANVAS");
		newCanvas.width = imageData.width;
		newCanvas.height = imageData.height;

		newCanvas.getContext("2d").putImageData(imageData, 0, 0);

		// Second canvas, for scaling
		var scaleCanvas = document.createElement("CANVAS");
		scaleCanvas.width = 1200;
		scaleCanvas.height = 256;
		var scaleCtx = scaleCanvas.getContext("2d");

		scaleCtx.imageSmoothingEnabled = true;
		scaleCtx.scale(xs, ys);
		scaleCtx.drawImage(newCanvas, 0, 0);

		var scaledImageData = scaleCtx.getImageData(0, 0, scaleCanvas.width, scaleCanvas.height);

		return scaledImageData;
	}

	printWParade(ctx, dl, dr, dy, largeTicksAmount, largeTicksWidth) {
		ctx.translate(0.5 + dl, 0.5 + dy);
		let w = ctx.canvas.width - dl - dr;
		let h = ctx.canvas.height - 2 * dy;
		let largeTickHeight = h / largeTicksAmount;
		ctx.strokeStyle = this.ticksColor; //"rgb(151,112,10)";
		let shortTicksWidth = 5;

		ctx.beginPath();
		for (let i = 0; i <= largeTicksAmount; i++) {
			ctx.moveTo(-shortTicksWidth, Math.floor(i * largeTickHeight + 0.5));
			ctx.lineTo(largeTicksWidth + 0.5, Math.floor(i * largeTickHeight + 0.5));
		}
		//ctx.lineWidth = 1;
		ctx.stroke();
		//ctx.closePath();

		let shortTicksAmount = 4 * largeTicksAmount;
		let shortTickHeight = h / shortTicksAmount;
		ctx.beginPath();
		for (
			let i = 0;
			i <= shortTicksAmount;
			i++ //if (i%4)
		) {
			ctx.moveTo(-shortTicksWidth, Math.floor(i * shortTickHeight + 0.5));
			ctx.lineTo(0, Math.floor(i * shortTickHeight + 0.5));

			ctx.moveTo(largeTicksWidth, Math.floor(i * shortTickHeight + 0.5));
			ctx.lineTo(largeTicksWidth + shortTicksWidth, Math.floor(i * shortTickHeight + 0.5));
		}
		//ctx.lineWidth = 1;
		ctx.stroke();
		//ctx.closePath();

		ctx.translate(-dl + 5, -2.0);
		let fontSize = 10;
		ctx.font = "10px Arial";
		ctx.fillStyle = "white";
		ctx.fillText("0.00", 2, 128 + 128 + fontSize / 2);
		ctx.fillText("0.25", 2, 128 + 64 + fontSize / 2);
		ctx.fillText("0.50", 2, 128 + fontSize / 2);
		ctx.fillText("0.75", 2, 128 - 64 + fontSize / 2);
		ctx.fillText("1.00", 2, 128 - 128 + fontSize / 2);

		// ctx.translate(largeTicksWidth+dl+dr, 0.0);
		// ctx.fillText("0.00",  2, 128+128+fontSize/2);
		// ctx.fillText("0.25",  2, 128+64+fontSize/2);
		// ctx.fillText("0.50",  2, 128+fontSize/2);
		// ctx.fillText("0.75",  2, 128-64+fontSize/2);
		// ctx.fillText("1.00",  2, 128-128+fontSize/2);

		// ctx.translate(-0.5-largeTicksWidth-dr-5, -0.5-dy+2);
	}

	doParade(src, width, height, canvas_output) {
		let dl = 40,
			dr = 10,
			dy = 10; // extra canvas spacing left and right, top and buttom
		let W = width,
			H = height;
		let w = W,
			h = 256;

		let channelWidth = 290;
		canvas_output.width = channelWidth * 3 + dl + dr;
		canvas_output.height = 256 + 2 * dy;

		var ctx = canvas_output.getContext("2d");

		if (this.lastParadeImgData == null || this.lastParadeWidth != w * 3 || this.lastParadeHeight != h)
			this.lastParadeImgData = ctx.createImageData(w * 3, h);

		var p = 0;
		//for (let y = 0; y < h; y++)	for (let  x = 0; x < w*3; x++, p+=4)
		let elems = h * w * 3 * 4;
		for (let p = 0; p < elems; p += 4) {
			this.lastParadeImgData.data[p] = 0;
			this.lastParadeImgData.data[p + 1] = 0;
			this.lastParadeImgData.data[p + 2] = 0;
			this.lastParadeImgData.data[p + 3] = 255;
		}

		let dst = this.lastParadeImgData.data;
		let offset = [0, w, 2 * w];
		let maximum = [0, 0, 0];
		let count = 0;
		for (let y = 0; y < H; y++)
			for (let x = 0; x < W; x++)
				for (let i = 0; i < 3; i++) {
					let Y = 255 - src[(y * W + x) * 4 + i];
					let I = (Y * 3 * w + /*Math.floor(x * ((w-1)/(W-1)))*/ x + offset[i]) * 4 + i;
					if (dst[I] < 0xff) dst[I] += 0x0f;
				}

		ctx.putImageData(this.lastParadeImgData, 0, 0);
		ctx.imageSmoothingEnabled = true;
		var data = this.scaleImageData(this.lastParadeImgData, (channelWidth * 3) / (3 * W), 1);
		ctx.imageSmoothingEnabled = false;
		canvas_output.width = channelWidth * 3 + dl + dr;
		canvas_output.height = 256 + 2 * dy;

		// ctx.fillRect(0,0,canvas_output.width,canvas_output.height);
		ctx.putImageData(data, dl, dy);
		//printH(ctx, 24, 8);
		this.printWParade(ctx, dl, dr, dy, 8, channelWidth * 3);
	}

	doWaveForm(src, width, height, canvas_output) {
		let dl = 40,
			dr = 10,
			dy = 10; // extra canvas spacing left and right, top and buttom
		let W = width,
			H = height;
		let w = W,
			h = 256;

		let channelWidth = 870;
		canvas_output.width = channelWidth + dl + dr;
		canvas_output.height = 256 + 2 * dy;
		// canvas_output.width = width;
		// canvas_output.height= 256;

		var ctx_waveform = canvas_output.getContext("2d");
		var imgData = ctx_waveform.createImageData(w, h);
		let dst = imgData.data;

		var p = 0;
		for (let y = 0; y < 256; y++)
			for (let x = 0; x < width; x++, p += 4) {
				dst[p] = 0;
				dst[p + 1] = 0;
				dst[p + 2] = 0;
				dst[p + 3] = 255;
			}

		let i = 0;
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++, i += 4) {
				let ry = 255 - src[i];
				let rIndex = (ry * width + x) * 4;
				if (dst[rIndex] < 0xff) dst[rIndex] += 0x0f;

				let gy = 255 - src[i + 1];
				let gIndex = (gy * width + x) * 4 + 1;
				if (dst[gIndex] < 0xff) dst[gIndex] += 0x0f;

				let by = 255 - src[i + 2];
				let bIndex = (by * width + x) * 4 + 2;
				if (dst[bIndex] < 0xff) dst[bIndex] += 0x0f;
			}
		}

		ctx_waveform.putImageData(imgData, 0, 0);
		ctx_waveform.imageSmoothingEnabled = true;

		var data = this.scaleImageData(imgData, channelWidth / W, 1);
		ctx_waveform.imageSmoothingEnabled = false;

		canvas_output.width = channelWidth + dl + dr;
		canvas_output.height = 256 + 2 * dy;

		ctx_waveform.fillRect(0, 0, canvas_output.width, canvas_output.height);
		ctx_waveform.putImageData(data, dl, dy);
		ctx_waveform.imageSmoothingEnabled = false;

		this.printWParade(ctx_waveform, dl, dr, dy, 8, channelWidth);
	}

	drawBracket(x, y, len, ctx_vectorscope, txt) {
		let third = len / 3.0;
		let sixth = len / 6.0;
		let half = len / 2.0;
		ctx_vectorscope.beginPath();

		ctx_vectorscope.moveTo(x - half, y - sixth);
		ctx_vectorscope.lineTo(x - half, y - half);
		ctx_vectorscope.lineTo(x - half + third, y - half);

		ctx_vectorscope.moveTo(x - half, y + sixth);
		ctx_vectorscope.lineTo(x - half, y + half);
		ctx_vectorscope.lineTo(x - half + third, y + half);

		ctx_vectorscope.moveTo(x + half, y + sixth);
		ctx_vectorscope.lineTo(x + half, y + half);
		ctx_vectorscope.lineTo(x + half - third, y + half);

		ctx_vectorscope.moveTo(x + half, y - sixth);
		ctx_vectorscope.lineTo(x + half, y - half);
		ctx_vectorscope.lineTo(x + half - third, y - half);

		ctx_vectorscope.stroke();

		ctx_vectorscope.fillText(txt, x + half + 2, y + half + 4);
	}

	doVectorScope(src, width, height, canvas_output) {
		canvas_output.width = 256;
		canvas_output.height = 256;
		var ctx_vectorscope = canvas_output.getContext("2d");
		var imgData = ctx_vectorscope.createImageData(256, 256);
		let dst = imgData.data;

		var p = 0;
		for (let y = 0; y < 256; y++)
			for (let x = 0; x < 256; x++, p += 4) {
				dst[p] = 0;
				dst[p + 1] = 0;
				dst[p + 2] = 0;
				dst[p + 3] = 255;
			}

		let i = 0;
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++, i += 4) {
				// converting rgb to yuv
				let r = src[i];
				let g = src[i + 1];
				let b = src[i + 2];

				let Y = Math.floor(0.5 + 0.299 * r + 0.587 * g + 0.114 * b);
				let U = Math.floor(0.5 + -0.169 * r - 0.331 * g + 0.5 * b + 128);
				let V = Math.floor(0.5 + 0.5 * r - 0.419 * g - 0.081 * b + 128);

				if (Y < 0) Y = 0;
				else if (Y > 255) Y = 255;

				if (U < 0) U = 0;
				else if (U > 255) U = 255;

				if (V < 0) V = 0;
				else if (V > 255) V = 255;

				let dx = U;
				let dy = 255 - V;
				let dIndex = (dy * 256 + dx) * 4;
				if (dst[dIndex] < 0xff) {
					dst[dIndex] += 0x0f;
					dst[dIndex + 1] += 0x0f;
					dst[dIndex + 2] += 0x0f;
				}
			}
		}
		ctx_vectorscope.putImageData(imgData, 0, 0);
		ctx_vectorscope.strokeStyle = this.ticksColor;
		//ctx_vectorscope.strokeStyle = "rgb(124,100,27)";
		var centerX = canvas_output.width / 2;
		var centerY = canvas_output.height / 2;
		var radius = canvas_output.width / 2 - 1;
		ctx_vectorscope.beginPath();
		ctx_vectorscope.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
		ctx_vectorscope.stroke();
		ctx_vectorscope.closePath();

		ctx_vectorscope.beginPath();
		ctx_vectorscope.moveTo(centerX, 0);
		ctx_vectorscope.lineTo(centerX, canvas_output.height - 1);
		ctx_vectorscope.moveTo(0, centerY);
		ctx_vectorscope.lineTo(canvas_output.width - 1, centerY);
		ctx_vectorscope.stroke();
		ctx_vectorscope.closePath();

		ctx_vectorscope.translate(centerX, centerY);
		let iPointX,
			iPointY,
			oPointX,
			oPointY,
			len1 = 0,
			len2 = 5;
		for (let i = 1; i <= 60; i++) {
			let angle = (Math.PI / 30) * i;
			let sineAngle = Math.sin(angle);
			let cosAngle = -Math.cos(angle);
			//Hour Ticks
			if (i % 2 == 0) {
				//ctx_vectorscope.lineWidth = 2;
				iPointX = sineAngle * (radius - len1);
				iPointY = cosAngle * (radius - len1);
				oPointX = sineAngle * (radius - 2 * len2);
				oPointY = cosAngle * (radius - 2 * len2);
			} else {
				//ctx_vectorscope.lineWidth = 1;
				iPointX = sineAngle * (radius - len1);
				iPointY = cosAngle * (radius - len1);
				oPointX = sineAngle * (radius - len2);
				oPointY = cosAngle * (radius - len2);
			}
			ctx_vectorscope.beginPath();
			ctx_vectorscope.moveTo(iPointX, iPointY);
			ctx_vectorscope.lineTo(oPointX, oPointY);
			ctx_vectorscope.stroke();
			//ctx_vectorscope.closePath();
		}
		ctx_vectorscope.font = "10px Arial";
		ctx_vectorscope.fillStyle = this.ticksColor;

		this.drawBracket(20, 85, 22, ctx_vectorscope, "C"); //c
		this.drawBracket(-70, 70, 22, ctx_vectorscope, "G"); //g
		this.drawBracket(-82, -7, 22, ctx_vectorscope, "Y"); //y
		this.drawBracket(-21, -80, 22, ctx_vectorscope, "R"); //r
		this.drawBracket(65, -73, 22, ctx_vectorscope, "M"); //m
		this.drawBracket(82, 7, 22, ctx_vectorscope, "B"); //b
	}
}
